import {ARRANGEMENT_TRACK_PATTERN} from '../constants.js';
import {setSelectedArrangementEvents} from 'actions/index.js';

class SplitPianoRollPattern {
    constructor(track, pattern, step) {
        this.track = track;
        this.pattern = pattern;
        this.step = step;
   }

    execute() {
        let newPattern = this.pattern.split(this.step);
        this.track.patterns.push(newPattern);
        this.track.updateSteps(true);
        let selectedEvents = {};
        selectedEvents[ARRANGEMENT_TRACK_PATTERN] = newPattern;
        this.track.sequencerEngine.store.dispatch(
            setSelectedArrangementEvents(selectedEvents));
    }
}

export default SplitPianoRollPattern;
